/**
 * Random Offer niche samples - 4-mezős élethű kitöltés az Ajánlat Varázsló
 * DEMO gombjához. UGYANAZ a 10 niche, mint a randomAvatarSamples.js-ben,
 * hogy a két agent ugyanazokat a bevált példákat használja.
 *
 * A 4 mező:
 *   nagy_otlet     - mit nyújt a program
 *   vegeredmeny    - konkrét végeredmény, mit lát/érez az ügyfél a végére
 *   lepesek        - időtartam + hány fázis
 *   ajanlat_forma  - hogyan dolgoznak együtt (format + ritmus + eszközök)
 */
export const OFFER_RANDOM_SAMPLES = [
  {
    niche: "High-ticket coachok prémium ügyfélszerzése",
    values: {
      nagy_otlet:
        "90 napos mentorprogram szoló business coachoknak, amiben felépítünk egy prémium webinar funnelt és egy letisztult $3-10k árpontos ajánlatot.",
      vegeredmeny:
        "90 nap alatt havi $30k+ stabil bevétel, heti 3 munkanapos működés, és minősített beszélgetések jönnek magától - autoritás a niche-ben.",
      lepesek: "90 nap, 3 fázis (Reposition → Rebuild → Reactivate)",
      ajanlat_forma:
        "1:1 mentorprogram: heti 60 perces Zoom, Voxer napi coaching, webinar script + landing sablonkészlet, heti visszajelzés az élesben futó kampányokra.",
    },
  },
  {
    niche: "Inzulinrezisztens nők fogyása",
    values: {
      nagy_otlet:
        "12 hetes online életmód-mentorprogram inzulinrezisztenciával küzdő 35+ nőknek, lab + étrend + mozgás protokollal.",
      vegeredmeny:
        "12 hét alatt visszakapott ruhaméret, reggeli frissesség, stabil energia a családhoz és a munkához - diéta nélkül, fenntartható mindennapi rendszerrel.",
      lepesek: "12 hét, 4 fázis (lab + felmérés → alapprotokoll → optimalizálás → fenntartás)",
      ajanlat_forma:
        "Csoportos high-ticket program: heti csoportos coaching, 2 egyéni session, zárt WhatsApp közösség, receptvault, napi rituálé-tracker app.",
    },
  },
  {
    niche: "Megfelelési kényszeres nők határhúzása",
    values: {
      nagy_otlet:
        "8 hetes 1:1 coaching program karrierben sikeres, de kapcsolataikban kimerült 35+ nőknek self-worth és határhúzás témájában.",
      vegeredmeny:
        "8 hét alatt bűntudat-mentes nemet mondani képesség, hiteles kapcsolatok, saját igények elsőbbsége, és belső nyugalom a konfliktusok közepén is.",
      lepesek: "8 hét, 4 fázis (felismerés → belső munka → gyakorlat → integráció)",
      ajanlat_forma:
        "1:1 mentorprogram: heti 60 perces session, napi mini audio-visszajelzések, practical határhúzás gyakorlatkönyv, zárt mentori közösség.",
    },
  },
  {
    niche: "Tanácsadók webinarból ügyfélszerzése",
    values: {
      nagy_otlet:
        "60 napos done-for-you webinar funnel build-out B2B consultantoknak - hirdetéstől a hívásig kulcsra kész rendszer.",
      vegeredmeny:
        "60 nap alatt heti 5-10 minősített discovery hívás a naptárban, előrejelezhető havi ügyfél-inflow, skálázható rendszer ami nélkülük is megy.",
      lepesek: "60 nap DFY delivery, heti eredménnyel",
      ajanlat_forma:
        "Done-for-you szolgáltatás: webinar script + landing + hirdetéskezelés + CRM setup + sales script - átadás + 30 napos optimalizációs support.",
    },
  },
  {
    niche: "30+ szinglik tudatos párválasztása",
    values: {
      nagy_otlet:
        "6 hónapos Conscious Dating mentorprogram 30+ szingli nőknek, ami összeköti a self-work-öt a gyakorlati randi-stratégiával.",
      vegeredmeny:
        "6 hónap alatt egészséges reciprok kapcsolat egy érzelmileg elérhető partnerrel - család lehetőségével, nyugodt magabiztossággal a randizás körül.",
      lepesek: "6 hónap, 4 fázis (self-audit → emotional filter → aktív randizás → kapcsolat)",
      ajanlat_forma:
        "Csoportos high-ticket: heti csoportos coaching, 4 egyéni session, zárt Dating Playbook, self-regulation videókurzus, mentori közösség.",
    },
  },
  {
    niche: "Vállalkozók kiszervezés és rendszerépítés",
    values: {
      nagy_otlet:
        "90 napos SystemsOS mentorprogram szoló vállalkozóknak és ügynökségi tulajdonosoknak, amiben kiszervezzük a kulcs-műveleteket és felépítünk egy SOP vaultot.",
      vegeredmeny:
        "90 nap alatt heti 30 óra felszabadított idő, megbízható csapat viszi a napi ops 70%-át, tulajdonos stratégiai munkára fókuszál.",
      lepesek: "90 nap, 3 fázis (audit + feltérképezés → SOP dokumentáció → asszisztens felvétel + betanítás)",
      ajanlat_forma:
        "1:1 mentorprogram: heti 60 perces stratégiai Zoom, Slack hozzáférés, Founder's Freedom framework sablontár, DFY asszisztens-hiring segítség.",
    },
  },
  {
    niche: "Életközépválságos férfiak karrierváltása",
    values: {
      nagy_otlet:
        "6 hónapos karrier-reset mentorprogram 40-55 éves vezető pozíciójú férfiaknak, ami feltárja a valós hívást és kidolgoz egy exit stratégiát.",
      vegeredmeny:
        "6 hónap alatt egy tiszta irány ami ÉS energiát ad ÉS pénzt hoz ÉS családi életet enged - konkrét 'next chapter' tervvel a végén.",
      lepesek: "6 hónap, 4 fázis (Archetype → Strengths → Market-fit → Exit plan)",
      ajanlat_forma:
        "1:1 prémium mentor: havi 2 csoportos call, kéthetente egyéni stratégia, heti async review Loomon keresztül, éves maradék support.",
    },
  },
  {
    niche: "Online tanfolyam készítők értékesítése",
    values: {
      nagy_otlet:
        "60 napos Launch Accelerator program course creator-öknek, amiben felépítjük a teljes 7-számjegyű launch gépezetet (emailek, oldal, webinar, hirdetés).",
      vegeredmeny:
        "60 nap után egy launch ami 6-7 számjegyű bevételt hoz, dokumentált és ismételhető, stressz nélkül - nem szerencse, hanem rendszer.",
      lepesek: "60 nap, 2 fázis (build-out → live launch)",
      ajanlat_forma:
        "Csoportos high-ticket + DFY hybrid: heti csoportos call, 7-Figure Launch OS blueprint, DFY email + webinar review, live launch support hét.",
    },
  },
  {
    niche: "Leendő apák önismereti felkészülése",
    values: {
      nagy_otlet:
        "8 hetes 'Ready for Fatherhood' 1:1 coaching program első gyereket váró 30-40 éves férfiaknak, ami feltárja a saját apa-mintát és új identitást épít.",
      vegeredmeny:
        "8 hét után érkezésre kész, jelenlévő apa-identitás, erős kapcsolat a partnerrel, tiszta férfi-érzés - érkezésig konkrét új self-image.",
      lepesek: "8 hét, 3 fázis (apakép feldolgozás → érzelmi eszköztár → new father identity design)",
      ajanlat_forma:
        "1:1 mentorprogram: heti 60 perces Zoom, napi rövid audio-visszajelzés, saját férfi-identitás journaling workbook, partner-konzultáció hívás.",
    },
  },
  {
    niche: "Finom textil kisvállalkozók skálázása",
    values: {
      nagy_otlet:
        "90 napos e-commerce Growth program saját márkás textil és home decor kisvállalkozóknak - Shopify funnel, hirdetés és CRM build-out.",
      vegeredmeny:
        "90 nap alatt stabil havi 10-20M Ft forgalom, automata email flow, hirdetés-ROAS 3x+, csapat viszi a napi operációt.",
      lepesek: "90 nap, 3 fázis (funnel audit → email + Shopify optimalizáció → hirdetés scale)",
      ajanlat_forma:
        "Done-for-you + coaching hybrid: heti 60 perces stratégia, DFY Klaviyo email flow setup, Shopify upsell implementáció, hirdetéskezelés 60 napig.",
    },
  },
];

export function pickRandomOfferSample(avatarBlueprint = null) {
  const base =
    OFFER_RANDOM_SAMPLES[Math.floor(Math.random() * OFFER_RANDOM_SAMPLES.length)];

  // If no Avatar passed, return the stock niche sample (legacy behaviour).
  if (!avatarBlueprint || typeof avatarBlueprint !== "object") return base;

  // Avatar-aware fill: synthesize Q01-Q04 directly from the saved Avatar
  // profile so the DEMO is ALWAYS tied to the currently-selected Avatar.
  // We still pick a random niche label for the toast "Niche: …" chip, but
  // the actual 4-field content references the Avatar by name, age, profession,
  // pain points, and desires.
  const ak = avatarBlueprint.alapkep || {};
  const nev = (ak.nev || "").trim();
  const kor = (ak.kor || "").toString().trim();
  const szakma = (ak.szakma || "").trim();
  const vagyProfil = avatarBlueprint.vagyprofil || {};
  const vagyak = avatarBlueprint.vagyai || {};
  const fajdalom = avatarBlueprint.fajdalomprofil || {};
  const topVagyak = Array.isArray(vagyProfil.top_5_vagy)
    ? vagyProfil.top_5_vagy.slice(0, 2)
    : [];
  const topFajdalmak = Array.isArray(fajdalom.top_5_fajdalompont)
    ? fajdalom.top_5_fajdalompont.slice(0, 2)
    : [];
  const kulsoCel = (vagyak.kulso_cel || "").trim();
  const belsoVagy = (vagyak.belso_vagy || "").trim();

  // Audience phrase: "40 éves HR vezető" or just "HR vezető" or generic
  const koros =
    kor && /^\d/.test(kor)
      ? `${kor} éves ${szakma || "szakmabeli"}`
      : szakma || "szakmabeli";
  const nevref = nev ? `${nev}` : "az Avatarod";

  const vegeredmenyParts = [];
  if (kulsoCel) vegeredmenyParts.push(kulsoCel);
  else if (topVagyak.length > 0) vegeredmenyParts.push(topVagyak[0]);
  if (belsoVagy) vegeredmenyParts.push(belsoVagy);
  const vegeredmeny =
    vegeredmenyParts.length > 0
      ? `${nevref} a program végére: ${vegeredmenyParts.join(" · ")}`
      : `${nevref} a program végére: stabil belső irány, működő napi rendszer, visszatérő magabiztosság.`;

  const fajdalomBlokk =
    topFajdalmak.length > 0
      ? topFajdalmak.map((f) => `- ${f}`).join(" ")
      : "a jelenlegi fájdalompontjaira szabva";

  return {
    niche: `${nevref}${szakma ? ` (${szakma})` : ""}`,
    values: {
      nagy_otlet: `12 hetes mentorprogram ${nevref} számára (${koros}), ami pont azokat a blokkokat veszi le, amikkel jelenleg küzd: ${fajdalomBlokk}.`,
      vegeredmeny,
      lepesek: "12 hét, 4 fázis (audit → alap-kiépítés → mélyítés → fenntartás)",
      ajanlat_forma:
        "Csoportos high-ticket: heti csoportos coaching, 2 egyéni session, zárt közösség, sablontár, napi mikro-visszajelzés.",
    },
  };
}
